<script>
export default {
  name: 'ChatIcon',
  props: {
    channelType: {
      type: String,
      required: true,
      default: 'unknown',
    },
  },
  computed: {
    iconClass() {
      const channelIconMap = {
        whatsapp: 'i-ri-whatsapp-line',
        web: 'i-ri-global-line',
        email: 'i-ri-mail-line',
        unknown: 'i-ri-chat-1-line',
      };

      return channelIconMap[this.channelType] || channelIconMap.unknown;
    },
  },
};
</script>

<template>
  <span :class="`w-6 h-6 ${iconClass}`" />
</template>
